import React, {Component} from 'react';
import {t} from 'l10n';

import {formatLastOnlineDate} from 'utils/user';
import 'sass/headers/headerProfile.scss';

class HeaderBrief extends Component {
    render() {
        const  {user, online} = this.props;

        return (
            <header className="profile-header-brief">
                <div className="content">
                    <div className="content-top">
                        <h1>
                            {user.nick}
                        </h1>
                        {online ?
                            <div className="online-status">
                                <span className="status active"/>
                                <span className="info">
                                    {t('I am online at')} <a href={online.room_url}
                                                             target="_blank">{online.room_name}</a>
                                </span>
                            </div>
                            :
                            <div className="online-status">
                                <span className="status"/>
                                <span className="info">
                                    {t('Last online at %1', formatLastOnlineDate(user))}
                                </span>
                            </div>
                        }
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderBrief;


// WEBPACK FOOTER //
// ./src/components/profile/HeaderBrief.js